import { render, staticRenderFns } from "./ScrollContainer.vue?vue&type=template&id=74187154&scoped=true"
import script from "./ScrollContainer.vue?vue&type=script&lang=js"
export * from "./ScrollContainer.vue?vue&type=script&lang=js"
import style0 from "./ScrollContainer.vue?vue&type=style&index=0&id=74187154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74187154",
  null
  
)

export default component.exports